import { render, staticRenderFns } from "./reset-password-bb.vue?vue&type=template&id=20925e94&scoped=true"
import script from "./reset-password-bb.vue?vue&type=script&lang=js"
export * from "./reset-password-bb.vue?vue&type=script&lang=js"
import style0 from "./reset-password-bb.vue?vue&type=style&index=0&id=20925e94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20925e94",
  null
  
)

export default component.exports